import {
  Bookmark,
  Bot,
  Network,
  Plus,
  Shield,
  Sparkles,
  UserPlus,
  Users,
  Zap,
} from 'lucide-react';

export const globalSearchSuggestedActionsFixture = [
  { id: 'create-work-item', label: 'Create work item', icon: Plus, shortcutKey: 'C' },
  { id: 'invite-member', label: 'Invite member', icon: UserPlus, shortcutKey: 'I' },
  { id: 'new-automation', label: 'New automation', icon: Zap, shortcutKey: 'N' },
];

export const globalSearchRecentItemsFixture = [
  {
    id: 'recent-1',
    title: 'Lead triage',
    subtitle: 'Network · 8 agents · 96.6% success · 1h ago',
    icon: Network,
    iconBg: 'LightBlue',
    iconColor: 'LightBlue',
  },
  {
    id: 'recent-2',
    title: 'Sammy — Service Desk',
    subtitle: 'Agent · in workspace · 2h ago',
    icon: Bot,
    iconBg: 'Purple',
    iconColor: 'Purple',
  },
  {
    id: 'recent-3',
    title: 'PRD-459 Multi-tenant agent rollout',
    subtitle: 'Ticket · open · Edgardo Sierra · 3h ago',
    icon: Bookmark,
    iconBg: 'Primary',
    iconColor: 'PrimaryAlt',
  },
  {
    id: 'recent-4',
    title: 'P-2025-014 PII redaction',
    subtitle: 'Policy · draft · Miguel Torres · 4h ago',
    icon: Shield,
    iconBg: 'Green',
    iconColor: 'Green',
  },
  {
    id: 'recent-5',
    title: 'Thomas Gonzalez',
    subtitle: 'Person · Owner · thomas@aimsos.ai · 5h ago',
    initials: 'TH',
    iconBg: 'Primary',
  },
];

export const globalSearchResultsFixture = Array.from({ length: 12 }, (_, index) => ({
  id: `result-${index + 1}`,
  title: 'Lead triage',
  subtitle: 'Network · 8 agents · 96.6% success · 1h ago',
  icon: Network,
  iconBg: 'LightBlue',
  iconColor: 'LightBlue',
}));

export const globalSearchFewResultsFixture = globalSearchResultsFixture.slice(0, 3);

export const globalSearchActiveFiltersFixture = [
  { id: 'owner-me', label: 'owner: me' },
  { id: 'type-conversations', label: 'type: conversation' },
  { id: 'status-active', label: 'status: active' },
];

export const globalSearchAppliedFiltersFixture = [
  'owner-me',
  'type-conversations',
  'status-active',
];

export const globalSearchLoadingFilterFixture = [
  { id: 'type-networks', label: 'type: network' },
];

/** Storybook / docs i18n labels (mirrors core-shell `topNav.globalSearch`). */
export const globalSearchLabelsFixture = {
  dialogTitle: 'Global search',
  esc: 'esc',
  cancel: 'Cancel',
  all: 'All',
  agents: 'Agents',
  channels: 'Channels',
  conversations: 'Conversations',
  people: 'People',
  networks: 'Networks',
  tickets: 'Tickets',
  policies: 'Policies',
  workspaces: 'Workspaces',
  filterType: 'Type',
  filterOwner: 'Owner',
  filterStatus: 'Status',
  ownerMe: 'Me',
  ownerEdgardo: 'Edgardo Sierra',
  ownerSarah: 'Sarah Chen',
  ownerMarcus: 'Marcus Reid',
  statusActive: 'Active',
  statusDraft: 'Draft',
  statusOpen: 'Open',
  statusInProgress: 'In progress',
  statusDone: 'Done',
  statusArchived: 'Archived',
  clearAll: 'Clear all',
  done: 'Done',
  suggestedActions: 'Suggested actions',
  popularThisWeek: 'Popular this week',
  recentSearches: 'Recent searches',
  noResultsTitle: 'No matches found',
  noResultsDescription: 'Try fewer words or different keywords',
  clearFilters: 'Clear filters',
  showingResultsFor: 'Showing results for',
  searchAll: 'Search All',
  navigate: 'Navigate',
  open: 'Open',
  enter: 'Enter',
  advancedSearch: 'Advanced search',
  advancedFilters: 'Advanced filters',
  filtersTooltipTitle: 'Filters',
  filtersTooltipDescription: 'Refine by date, status, owner, tags',
  filtersAriaLabel: 'Search filters',
  errorMessage: 'Something went wrong. Please try again.',
  retry: 'Retry',
  seeAll: 'See all',
};

export const globalSearchModalPlaceholderFixture =
  'Search agents, networks, tickets, policies people...';

export const globalSearchGroupedResultsFixture = [
  {
    id: 'agents',
    label: 'Agents',
    icon: Sparkles,
    totalCount: 5,
    items: [
      { id: 'a-1', title: 'Lead triage agent', subtitle: 'Agent · active · 2h ago', icon: Bot, iconBg: 'Purple', iconColor: 'Purple' },
      { id: 'a-2', title: 'Support agent', subtitle: 'Agent · active · 3h ago', icon: Bot, iconBg: 'Purple', iconColor: 'Purple' },
      { id: 'a-3', title: 'Billing agent', subtitle: 'Agent · draft · 1d ago', icon: Bot, iconBg: 'Purple', iconColor: 'Purple' },
    ],
  },
  {
    id: 'networks',
    label: 'Networks',
    icon: Network,
    totalCount: 2,
    items: [
      { id: 'n-1', title: 'Customer success network', subtitle: 'Network · 4 agents · 98% success', icon: Network, iconBg: 'LightBlue', iconColor: 'LightBlue' },
      { id: 'n-2', title: 'Sales automation network', subtitle: 'Network · 6 agents · 91% success', icon: Network, iconBg: 'LightBlue', iconColor: 'LightBlue' },
    ],
  },
  {
    id: 'people',
    label: 'People',
    icon: Users,
    totalCount: 8,
    items: [
      { id: 'p-1', title: 'Edgardo Sierra', subtitle: 'Person · Owner · edgardo@aimsos.ai', initials: 'ES' },
      { id: 'p-2', title: 'Sarah Chen', subtitle: 'Person · Member · sarah@aimsos.ai', initials: 'SC' },
      { id: 'p-3', title: 'Marcus Reid', subtitle: 'Person · Member · marcus@aimsos.ai', initials: 'MR' },
    ],
  },
  {
    id: 'tickets',
    label: 'Tickets',
    icon: Bookmark,
    totalCount: 4,
    items: [
      { id: 't-1', title: 'PRD-459 Multi-tenant agent rollout', subtitle: 'Ticket · open · Edgardo Sierra', icon: Bookmark, iconBg: 'Primary', iconColor: 'PrimaryAlt' },
    ],
  },
];
